// Brand marks for social-login buttons. Inline SVG (no network), sized to fit a
// 20px box. Paths sourced from each brand's public guidelines / Simple Icons.

import type { JSX } from 'preact';

const Wrap = ({ size, children }: { size: number; children: JSX.Element | JSX.Element[] }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" style={{ display: 'block' }}>{children}</svg>
);

export const BrandX = ({ size = 20, color = '#fff' }: { size?: number; color?: string }) => (
  <Wrap size={size}>
    <path fill={color} d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24h-6.66l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25h6.81l4.713 6.231 5.467-6.231Zm-1.161 17.52h1.833L7.084 4.126H5.117L17.083 19.77Z"/>
  </Wrap>
);

export const BrandGoogle = ({ size = 20 }: { size?: number }) => (
  <Wrap size={size}>
    <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09Z"/>
    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0 0 12 23Z"/>
    <path fill="#FBBC05" d="M5.84 14.1A6.6 6.6 0 0 1 5.49 12c0-.73.13-1.44.35-2.1V7.07H2.18A11 11 0 0 0 1 12c0 1.78.43 3.46 1.18 4.94l3.66-2.84Z"/>
    <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.65l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84C6.71 7.3 9.14 5.38 12 5.38Z"/>
  </Wrap>
);

export const BrandFacebook = ({ size = 20 }: { size?: number }) => (
  <Wrap size={size}>
    <path fill="#1877F2" d="M24 12.07C24 5.4 18.63 0 12 0S0 5.4 0 12.07C0 18.1 4.39 23.1 10.13 24v-8.44H7.08v-3.49h3.05V9.41c0-3.02 1.79-4.69 4.53-4.69 1.31 0 2.69.23 2.69.23v2.97h-1.51c-1.49 0-1.96.93-1.96 1.89v2.26h3.32l-.53 3.49h-2.79V24C19.61 23.1 24 18.1 24 12.07Z"/>
    <path fill="#fff" d="M16.67 15.56l.53-3.49h-3.32V9.81c0-.96.47-1.89 1.96-1.89h1.51V4.95s-1.38-.23-2.69-.23c-2.74 0-4.53 1.67-4.53 4.69v2.66H7.08v3.49h3.05V24a12.2 12.2 0 0 0 3.75 0v-8.44h2.79Z"/>
  </Wrap>
);

export const BrandMail = ({ size = 20, color = 'currentColor' }: { size?: number; color?: string }) => (
  <Wrap size={size}>
    <path fill="none" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"
      d="M3 7l9 6 9-6M5 5h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2z"/>
  </Wrap>
);

export const BrandTelegram = ({ size = 20 }: { size?: number }) => (
  <Wrap size={size}>
    <circle cx="12" cy="12" r="12" fill="#229ED9"/>
    <path fill="#fff" d="M5.5 11.5l12-4.6c.6-.2 1.1.1.9.8l-2 9.5c-.1.6-.5.7-1 .4l-2.9-2.1-1.4 1.3c-.2.2-.3.3-.6.3l.2-2.9 5.4-4.9c.2-.2 0-.3-.3-.1l-6.6 4.2-2.9-.9c-.6-.2-.6-.6.2-.9z"/>
  </Wrap>
);
